import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AllocationWorkspaceDialogComponent } from './allocation-workspace.dialog';

export interface AllocationWorkspaceShiftEditContext {
  userGuid: string;
  userName: string;
  date: Date;
  siteGuid: string | null;
}

export interface AllocationWorkspaceOpenOptions {
  initialDate?: Date | null;
  initialUserGuid?: string | null;
  shiftEditContext?: AllocationWorkspaceShiftEditContext | null;
}

@Injectable({
  providedIn: 'root',
})
export class AllocationWorkspaceService {
  private modalCtrl = inject(ModalController);

  private activeModal: HTMLIonModalElement | null = null;

  async open(options?: AllocationWorkspaceOpenOptions): Promise<void> {
    if (this.activeModal) {
      return;
    }

    this.activeModal = await this.modalCtrl.create({
      component: AllocationWorkspaceDialogComponent,
      componentProps: {
        initialDate: options?.initialDate ?? null,
        initialUserGuid: options?.initialUserGuid ?? null,
        shiftEditContext: options?.shiftEditContext ?? null,
      },
      cssClass: ['workspace-modal', 'stack-modal'],
    });

    await this.activeModal.present();
    await this.activeModal.onDidDismiss();
    this.activeModal = null;
  }
}
